<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        class="my-1 text-none"
        v-bind="attrs"
        v-on="on"
        rounded
      >
        <v-icon left> mdi-plus </v-icon>
        Añadir Centro de Costo
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Nuevo Centro de Costo</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="editedItem.company_id"
                  :items="companies"
                  :rules="companyRules"
                  @change="listenCompany"
                  item-text="name"
                  item-value="id"
                  label="Empresa"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="editedItem.company_id">
                <v-select
                  v-model="editedItem.management_id"
                  :items="managements"
                  :rules="managementIdRules"
                  item-text="name"
                  item-value="id"
                  label="Gerencia"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.costCenter"
                  :rules="costCenterRules"
                  label="Centro de Costo"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.responsible_id"
                  :items="users"
                  :rules="responsibleRules"
                  item-text="fullName"
                  item-value="id"
                  label="Responsable"
                  required
                  @keyup="
										(v) => {
											listenSearch(v.target.value);
										}
									"
									:filter="customFilter"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue darken-1"
          :loading="isLoading"
          :disabled="isLoading"
          @click="save()"
          text
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "CreateCostCenterDialog",

  props: {},

  data: () => ({
    timeout: null,
		previousSearchValue: '',
    dialog: false,
    isValidFormDialog: false,
    nameRules: [(v) => !!v || "Campo requerido"],
    costCenterRules: [(v) => !!v || "Campo requerido"],
    managementIdRules: [(v) => !!v || "Campo requerido"],
    companyRules: [(v) => !!v || "Campo requerido"],
    responsibleRules: [(v) => !!v || "Campo requerido"],
    isLoading: false,
    editedItem: {
      name: "",
      costCenter: "",
      company_id: "",
      management_id: "",
      responsible_id: "",
    },
    defaultItem: {
      name: "",
      costCenter: "",
      company_id: "",
      management_id: "",
      responsible_id: "",
    },
  }),

  computed: {
    companies() {
      return this.$store.getters["companies/getCompaniesList"];
    },
    managements() {
      return this.$store.getters["managements/getManagementsList"];
    },
    validationErrors() {
      return this.$store.getters["costCenters/getValidationErrors"];
    },
    users() {
      return this.$store.getters["users/getUsers"];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
      if (val) {
        this.$store.dispatch("companies/getCompaniesList");
        this.$store.dispatch("users/getUsers");
      }
    },
  },

  methods: {
    listenSearch(value) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				const searchValue = value || '';
				const trimmedSearchValue = searchValue.trim();

				if (searchValue === '') {
					this.$store.dispatch('users/searchGetUsers', {
						search: '',
						active: true,
						searchType: 'select',
						pagination: false,
					});

					this.previousSearchValue = '';
					return;
				}

				if (trimmedSearchValue === '') {
					return;
				}

				if (this.previousSearchValue !== trimmedSearchValue) {
					this.$store.dispatch('users/searchGetUsers', {
						search: trimmedSearchValue,
						active: true,
						searchType: 'select',
						pagination: false,
					});

					this.previousSearchValue = trimmedSearchValue;
				}
			}, 600);
		},

		customFilter(item, queryText, itemText) {
			const searchTerms = queryText.toLowerCase().split(' ');
			const fullName = itemText.toLowerCase();

			return searchTerms.every((term) => fullName.includes(term));
		},

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("costCenters/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "green", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    listenCompany() {
      this.$store.dispatch("managements/getManagementsList", {
        company_id: this.editedItem.company_id,
      });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          let data = {
            name: this.editedItem.name.trim(),
            costCenter: this.editedItem.costCenter.trim(),
            pep_id: null,
            management_id: this.editedItem.management_id,
            responsible_id: this.editedItem.responsible_id,
          };
          await this.$store.dispatch("costCenters/saveCostCenter", data);
          this.showSnack("green", "Se ha registrado satisfactoriamente");
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
